import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "organ-add-page common-page"
};
import { ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import separateUpload from "@/components/separate-upload.vue";
import basicEditor from "@/components/basic-editor.vue";
import { ElMessage, ElForm, ElOption } from "element-plus";
import { addOrganApi, getDescByIdApi, updateOrganByIdApi } from "@/service/modules/organ";
export default /*@__PURE__*/_defineComponent({
  __name: 'organ-add',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const formRef = ref();
    const organId = ref(null);
    const form = ref({
      id: null,
      name: "",
      type: null,
      labels: "",
      contactName: "",
      status: 1,
      isRecommend: 0,
      mobile: "",
      address: "",
      logoUrl: "",
      brief: ""
    });
    const formRules = {
      name: [{
        required: true,
        message: "请输入机构名称",
        trigger: "blur"
      }],
      type: [{
        required: true,
        message: "请选择机构类型",
        trigger: "change"
      }],
      labels: [{
        required: true,
        message: "请输入机构分类",
        trigger: "blur"
      }],
      contactName: [{
        required: true,
        message: "请输入机构联系人",
        trigger: "blur"
      }],
      status: [{
        required: true,
        message: "请选择状态",
        trigger: "blur"
      }],
      mobile: [{
        required: true,
        message: "请输入机构电话",
        trigger: "blur"
      }],
      address: [{
        required: true,
        message: "请输入机构地址",
        trigger: "blur"
      }],
      logoUrl: [{
        required: true,
        message: "请上传图片",
        trigger: "change"
      }]
      // brief: [{ required: true, message: "请填写机构简介", trigger: "change" }],
    };
    const isLoading = ref(false);
    function handleUploadImg(img) {
      form.value.logoUrl = img;
    }
    function handleIntroChange(val) {
      console.log(123123);
      form.value.brief = val;
    }
    function handleToBack() {
      if (isLoading.value) return;
      router.back();
    }
    function handleSubmit() {
      formRef.value?.validate(validate => {
        if (validate) {
          submit();
        }
      });
    }
    async function submit() {
      try {
        isLoading.value = true;
        if (!organId.value) {
          let res = await addOrganApi(form.value);
          ElMessage.success("添加成功");
        } else {
          console.log("form", form.value);
          let res = await updateOrganByIdApi(organId.value, form.value);
          ElMessage.success("修改成功");
        }
        setTimeout(() => {
          router.back();
        }, 600);
      } catch {} finally {
        isLoading.value = false;
      }
    }
    // 单个机构详情
    async function getDescById() {
      if (organId.value) {
        try {
          let {
            data
          } = await getDescByIdApi(organId.value);
          form.value = data;
        } catch {}
      }
    }
    onMounted(() => {
      let query = route.query;
      if (query.id) {
        organId.value = Number(query.id);
        getDescById();
      }
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(ElForm), {
        "label-position": "left",
        "label-width": "100px",
        rules: formRules,
        ref_key: "formRef",
        ref: formRef,
        model: form.value
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "机构名称",
          prop: "name"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.value.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.name = $event),
            placeholder: "请输入机构名称"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "机构类型",
          prop: "name"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            placeholder: "请选择机构类型",
            modelValue: form.value.type,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.type = $event)
          }, {
            default: _withCtx(() => [_createVNode(_unref(ElOption), {
              label: "医疗机构",
              value: 0
            }), _createVNode(_unref(ElOption), {
              label: "康复机构",
              value: 1
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "机构分类",
          prop: "labels"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.value.labels,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.labels = $event),
            placeholder: "请输入机构分类（多个分类请用英文逗号(,)分隔）"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "机构联系人",
          prop: "contactName"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.value.contactName,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.contactName = $event),
            placeholder: "请输入机构联系人"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "机构电话",
          prop: "mobile"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.value.mobile,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.mobile = $event),
            placeholder: "请输入机构电话"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "机构地址",
          prop: "address"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.value.address,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.value.address = $event),
            placeholder: "请输入机构地址"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "是否启用",
          prop: "status"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_switch, {
            modelValue: form.value.status,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.value.status = $event),
            "active-value": 1,
            "inactive-value": 0
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "是否精选"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_switch, {
            modelValue: form.value.isRecommend,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => form.value.isRecommend = $event),
            "active-value": 1,
            "inactive-value": 0
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "机构封面",
          prop: "logoUrl"
        }, {
          default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(separateUpload, {
            img1Url: form.value.logoUrl,
            onUploadSuccess: handleUploadImg
          }, null, 8, ["img1Url"]), _cache[8] || (_cache[8] = _createElementVNode("div", {
            style: {
              "margin-top": "3px",
              "color": "#999"
            }
          }, " 上传图片宽度最佳为750px ", -1))])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "机构简介",
          prop: "brief"
        }, {
          default: _withCtx(() => [_createVNode(basicEditor, {
            onIntroChange: handleIntroChange,
            data: form.value.brief
          }, null, 8, ["data"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "danger",
            style: {
              "margin-right": "10px"
            },
            size: "default",
            onClick: handleToBack
          }, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode("返回")])),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            size: "default",
            onClick: handleSubmit,
            loading: isLoading.value
          }, {
            default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode("确定")])),
            _: 1
          }, 8, ["loading"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])]);
    };
  }
});